module.exports = __webpack_public_path__ + "static/media/11.258d36f0.jpg";